import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(c => c.LoginComponent)
  },
  {
    path: 'change-password',
    loadComponent: () => import('./pages/change-password/change-password.component').then(c => c.ChangePasswordComponent)
  },
  {
    path: 'fuse',
    loadChildren: () => import('./pages/vendors/fuse/fuse.routes'),
    data: {
      showStripeConnect: false
    }
  },
  {
    path: 'pal',
    loadChildren: () => import('./pages/vendors/fuse/fuse.routes'),
    data: {
      showStripeConnect: true
    }
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '**',
    redirectTo: 'login'
  }
];
